var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "canvas",
      staticClass: "canvas::editor-admin-Canvas relative",
      class: _vm.activeMode === "overview" ? "w-1/3" : "w-full",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeMode === "content",
              expression: "activeMode === 'content'",
            },
          ],
          staticClass: "absolute top-5 left-5 z-50",
        },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.copiedBlockId !== null,
                  expression: "copiedBlockId !== null",
                },
              ],
              ref: "pasteCanvasBlockButton",
              staticClass:
                "inline-flex items-center px-5 py-2 border transition border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 bg-opacity-50 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
              class: { "opacity-50 pointer-events-none": _vm.pastingBlock },
              on: {
                click: function ($event) {
                  return _vm.pasteCanvasBlock(_vm.canvasVersion)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pastingBlock,
                      expression: "pastingBlock",
                    },
                  ],
                  staticClass: "animate-spin -ml-1 mr-3 h-5 w-5",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("circle", {
                    staticClass: "opacity-25",
                    attrs: {
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "opacity-75",
                    attrs: {
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-medium text-lg leading-normal mb-0" },
                [_vm._v("Plak blok")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.activeMode === "overview" &&
                _vm.primaryLanguage !== _vm.language,
              expression:
                "activeMode === 'overview' && primaryLanguage !== language",
            },
          ],
          ref: "importBlocksBtn",
          staticClass:
            "block w-full border-2 border-dashed border-indigo-300 hover:bg-indigo-400 hover:border-transparent hover:text-white px-5 py-5 rounded text-center text-gray-500 transition-all",
          on: {
            click: function ($event) {
              return _vm.importCanvasBlocks(_vm.canvasVersion)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "font-medium text-lg leading-normal mb-0" },
            [
              _vm._v(
                "Importeer blokken van primaire taal (" +
                  _vm._s(_vm.primaryLanguage) +
                  ")"
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.activeMode === "overview" &&
      (_vm.canvasVersion.canvas_blocks.length == 0 || _vm.addInstruction.show)
        ? _c(
            "div",
            {
              staticClass:
                "bg-white border-1 border-gray-500 py-5 px-5 text-center m-3 addInstruction",
              class: {
                saving: _vm.stateSaving,
                hoveredForAddBlock: _vm.addInstruction.hoveredForAddBlock,
              },
              on: {
                dragover: function ($event) {
                  $event.preventDefault()
                  _vm.addInstruction.hoveredForAddBlock = true
                },
                dragleave: function ($event) {
                  $event.preventDefault()
                  _vm.addInstruction.hoveredForAddBlock = false
                },
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.onInstructionDrop.apply(null, arguments)
                },
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "text-xs mt-1" }, [
                _vm._v("(of klik het aan)"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeMode == "content" && _vm.canvasVersion.canvas_blocks.length == 0
        ? _c(
            "div",
            {
              staticClass:
                "bg-gray-50 border-1 border-gray-500 text-center absolute inset-0 z-10 flex justify-center items-center",
            },
            [
              _c("div", { staticClass: "flex flex-col items-center" }, [
                _c(
                  "svg",
                  {
                    staticClass: "w-32 h-32 text-gray-400 mb-5",
                    attrs: {
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("h6", { staticClass: "text-xl text-gray-400" }, [
                  _vm._v("Ga naar het overzicht om een blok toe te voegen"),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "zoomer",
          style: {
            transform: "scale(" + _vm.scale + ")",
            width: 100 / _vm.scale + "%",
            height:
              "calc(" +
              100 / _vm.scale +
              "% - " +
              (_vm.activeMode === "overview" &&
              _vm.primaryLanguage !== _vm.language
                ? (_vm.$refs.canvas.clientHeight /
                    _vm.$refs.importBlocksBtn.clientHeight) *
                    100 +
                  30
                : 0) +
              "px" +
              ")",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "h-full",
              style: {
                padding:
                  _vm.activeViewport != "xl"
                    ? 24 / _vm.scale + "px " + 16 / _vm.scale + "px"
                    : 0,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "h-full m-auto",
                  style: {
                    maxWidth:
                      _vm.activeMode != "overview"
                        ? _vm.viewportWidth + "px"
                        : "100%",
                  },
                },
                [
                  _c("document-iframe", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.activeMode == "content" ||
                          (_vm.activeMode == "overview" &&
                            _vm.canvasVersion.canvas_blocks.length > 0),
                        expression:
                          "activeMode == 'content' || (activeMode == 'overview' && canvasVersion.canvas_blocks.length > 0)",
                      },
                    ],
                    ref: "iframe",
                    attrs: {
                      canvasVersion: _vm.canvasVersion,
                      scale: _vm.scale,
                      activeMode: _vm.activeMode,
                    },
                    on: {
                      loaded: function ($event) {
                        return _vm.$emit("loaded")
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h5",
      { staticClass: "font-medium text-lg leading-normal mb-0" },
      [_vm._v("Drag & drop een blok"), _c("br"), _vm._v("van rechts")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }